import React, {
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
  useContext,
} from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from 'react-router-dom';
import Ping from 'ping.js';
import styled from 'styled-components';
import GlobalStyles from './components/globals/GlobalStyles';
import ExhibitorContext from './context/exhibitorContext';
import Register from './components/registrationForm/Register';
import RegisterIframe from './components/registrationForm/RegisterIframe';
import SliderPage from './pages/SliderPage';
import RegistrationForm from './components/registrationForm/RegistrationForm';
import { Provider as UserProvider } from './context/UserContext';
import { Provider as AttendantProvider } from './context/AttendantContext';
import { Provider as ClientProvider } from './context/ClientContext';
import { Context as SocketContext } from './context/SocketContext';
import ResetPassword from './components/registrationForm/ResetPassword';
import SiteData from './config';
import AttendantDashboard from './components/AttendantConsole/AttendantDashboard';
import AttendantTileEditor from './components/AttendantConsole/AttendantTileEditor';
import NavbarAttendant from './components/globals/NavbarAttendant';
import ForgotPassword from './components/registrationForm/ForgotPassword';
import ClientLogin from './components/ClientConsole/ClientLogin';
import ClientDashboard from './components/ClientConsole/ClientDashboard';
import NavbarClient from './components/ClientConsole/NavbarClient';
import AuditoriumPage from './pages/AuditoriumPage';
import AuditoriumPage2 from './pages/AuditoriumPage2';
import { NotificationMessage } from './components/globals/NotificationMessage';
import EndofEventPage from './pages/EndofEventPage';
import Axios from 'axios';

let ping_interval = null;
let missedCounter = 0;
const App = ({ className }) => {
  const [exhibitorData, setExhibitorData] = useState([]);
  const History = useHistory();

  const [loadGeneralChat, setLoadGeneralChat] = useState(false);
  const [loadTileChat, setLoadTileChat] = useState(false);
  const [loadAuditoriumChat, setloadAuditoriumChat] = useState(false);
  const [missedHeartbeats, setMissedHeartbeats] = useState(0);
  const [attendantNavbarBackLink, setAttendantNavbarBackLink] = useState(
    '/auditorium'
  );
  const [pingData, setpingData] = useState();
  const [missedPings, setmissedPings] = useState(0);
  const {
    state: {
      generalChatMessages,
      generalChatParticipants,
      auditoriumChatMessages,
      auditoriumChatParticipants,
      tileChatMessages,
      tileChatParticipants,
    },
    setTileChatMessages,
    setTileChatParticipants,
    setGeneralChatMessages,
    setGeneralChatParticipants,
    setAuditoriumChatMessages,
    setAuditoriumChatParticipants,
    setViewsNumber,
    setCategories,
    setLoadTileChatContext,
    setConnection,
  } = useContext(SocketContext);

  const ping = new Ping({ timeout: 230 });
  const generalChatMessagesRef = useRef(generalChatMessages);
  const generalChatParticipantsRef = useRef(generalChatParticipants);
  const tileChatMessagesRef = useRef(tileChatMessages);
  const tileChatParticipantsRef = useRef(tileChatParticipants);
  const auditoriumChatMessagesRef = useRef(auditoriumChatMessages);
  const auditoriumChatParticipantsRef = useRef(auditoriumChatParticipants);

  useLayoutEffect(() => {
    document.title = SiteData.titleIndex;
  }, []);

  // useEffect(() => {
  //   handlePing();
  // }, []);

  // const handlePing = () => {
  //   ping_interval = setInterval(() => {
  //     ping.ping(
  //       'https://status.digitalvirtualspaces.com',
  //       (err, data) => {
  //         missedCounter++;
  //         if (err) {
  //           if (missedCounter >= 5) {
  //             clearInterval(ping_interval);
  //             handleDoomsday();
  //           }
  //         } else {
  //           missedCounter = 0;
  //           console.log('healthy');
  //         }
  //       }
  //     );
  //   }, 5500);
  // };

  // const handleDoomsday = async () => {
  //   const { data } = await Axios.get(
  //     'https://nabj.mbvsbackend.com/api/dooms_day/1/'
  //   );
  //   if (data) {
  //     switch (data.status) {
  //       case 'good':
  //         missedCounter = 0;
  //         handlePing();
  //         break;

  //       case 'bad':
  //         const notification = {
  //           title: 'Attention',
  //           message: `Due to the volume of event traffic, we are currently experiencing technical difficulties. Please check your email inbox for instructions on how to join today’s sessions. Thank you for your patience.`,
  //           type: 'danger',
  //           insert: 'top',
  //           container: 'top-center',
  //           duration: 180000,
  //         };
  //         NotificationMessage(notification);
  //         // setTimeout(() => {
  //         //   window.open(
  //         //     'https://redirect.digitalvirtualspaces.com'
  //         //   );
  //         //   window.close();
  //         // }, 60000);
  //         break;

  //       default:
  //     }
  //   }
  // };

  return (
    <div className={className}>
      <GlobalStyles />
      <NotificationMessage />
      <UserProvider>
        <ExhibitorContext.Provider value={exhibitorData}>
          <AttendantProvider>
            <ClientProvider>
              <Router>
                <Switch>
                  <Route exact path="/">
                    {/* <Navbar /> */}
                    <SliderPage/>
                  </Route>
                  {SiteData.auditorium && SiteData.isMultipleAuditorium ? (
                    <Route exact path="/auditorium/:id">
                      <AuditoriumPage />
                    </Route>
                  ) : (
                    <Route exact path="/auditorium">
                      <AuditoriumPage />
                    </Route>
                  )}
                  {/* {SiteData.auditorium && (
                    <Route exact path="/auditorium2">
                      <AuditoriumPage2 />
                    </Route>
                  )} */}
                  {SiteData.auditorium && (
                    <Route exact path="/closing">
                      <EndofEventPage />
                    </Route>
                  )}
                  <Route path="/login">
                    {/* <LoginForm /> */}
                    <RegistrationForm />
                  </Route>
                  <Route path="/register">
                    {' '}
                    <RegisterIframe />{' '}
                  </Route>
                  <Route path="/register2">
                    {' '}
                    <Register />{' '}
                  </Route>
                  <Route path="/forgotpassword">
                    {' '}
                    <ForgotPassword />{' '}
                  </Route>
                  <Route path="/reset/:uuid/:token">
                    {' '}
                    <ResetPassword />{' '}
                  </Route>
                  <Route exact path="/dashboard">
                    <NavbarAttendant
                      attendantNavbarBackLink={attendantNavbarBackLink}
                    />
                    <AttendantDashboard
                      setAttendantNavbarBackLink={setAttendantNavbarBackLink}
                      loadGeneralChat={loadGeneralChat}
                      loadTileChat={loadTileChat}
                    />
                  </Route>
                  <Route exact path="/editor">
                    <NavbarAttendant
                      attendantNavbarBackLink={attendantNavbarBackLink}
                    />
                    <AttendantTileEditor />
                  </Route>
                  <Route exact path="/client">
                    <NavbarClient />
                    <ClientDashboard />
                  </Route>
                  <Route path="/clientlogin">
                    <ClientLogin />
                  </Route>
                  <Route
                    exact
                    path="/loaderio-faafa801558db05beec16c6856f2516e"
                  />
                  <Route path="*" render={(props) => <div>Not found!</div>} />
                </Switch>
              </Router>
            </ClientProvider>
          </AttendantProvider>
        </ExhibitorContext.Provider>
      </UserProvider>
    </div>
  );
};

export default styled(App)`
  height: 100%;
  width: 100%;
`;
